"use client";

/*
参考：https://docs.datadoghq.com/ja/real_user_monitoring/guide/monitor-your-nextjs-app-with-rum/?tab=npm
*/

import { datadogRum } from "@datadog/browser-rum";
import { GLOBALS } from "config";

datadogRum.init({
  applicationId: "b5ec8dff-2120-4cab-8ab7-ce5b34286390",
  clientToken: "pub7c50deabae6feabd4b0a1e551507b812",
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: "datadoghq.com",
  service: "comici-magazine",
  env: GLOBALS.APP_ID + "-" + GLOBALS.ENV,
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: "mask-user-input",
});

export function DatadogRUM() {
  return null;
}
